import { useContext, useState, useRef } from 'react';
import { LinearProgress } from '@mui/material';
import axios from 'axios';

import { Refuel } from '@/tmp';
import { refuels } from '@/tmp/TargetService';

import { ctxRefuel } from '@/contexts/RefuelsCtx';
import { rethrowIfNotClientException } from '@/utilities/throwableUtils';
import { StaticDateRangeSelect } from '@/components/common/date/StaticDateRangeSelect';
import DisplayNoResult from '../common/DisplayNoResult';

export function RefuelDateSelect({
  setRefuels,
  setSelectedDates,
}: {
  setRefuels: (values: Refuel[] | undefined) => void;
  setSelectedDates: (from: Date, to: Date) => void;
}) {
  const ctx = useContext(ctxRefuel);
  const [result, setResult] = useState<boolean | undefined>(undefined);

  const activeRequestIdRef = useRef(0);

  async function setValuesWrapper(from: Date, to: Date) {
    if (!ctx || !ctx?.selectedTarget || !from || !to) {
      setResult(undefined);
      return;
    }

    const requestId = ++activeRequestIdRef.current;
    ctx.setSelectedDates({ from: from, to: to });
    ctx.setLoading(true);

    try {
      const result = await refuels(ctx.selectedTarget, from, to);

      if (requestId !== activeRequestIdRef.current) {
        return;
      }

      const count = result.data?.length ?? 0;
      if (count === 0) {
        setResult(true);
        setRefuels(undefined);
      } else {
        setResult(undefined);
        setRefuels(result.data);
        setSelectedDates(from, to);
        if (count > 0) {
          ctx?.setTab(2);
        }
      }
      // TODO ne legyen any
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      if (axios.isCancel?.(error) || error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError') {
        return;
      }
      rethrowIfNotClientException(error);
    } finally {
      if (requestId === activeRequestIdRef.current) {
        ctx.setLoading(false);
      }
    }
  }

  function chooseNewVehicle() {
    setResult(undefined);
    ctx?.setSelectedTarget(undefined);
    ctx?.setTab(0);
  }

  function chooseNewDate() {
    setResult(undefined);
    ctx?.setSelectedDates(undefined);
  }

  return (
    <>
      {ctx?.loading && <LinearProgress />}
      {ctx?.selectedDates && result ? (
        <DisplayNoResult chooseNewDate={chooseNewDate} chooseNewVehicle={chooseNewVehicle} />
      ) : (
        <StaticDateRangeSelect
          setSelectedDates={setValuesWrapper}
          // currentValue={{ from: ctx?.selectedDates?.from ?? null, to: ctx?.selectedDates?.to ?? null }}
        />
      )}
    </>
  );
}
